module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-container"
  }, [_c('div', {
    staticClass: "login-wrapper"
  }, [_c('section', {
    staticClass: "login-content"
  }, [_c('h1', {
    staticClass: "mb-5"
  }, [_vm._v(_vm._s(_vm.$t('login.login')))]), _vm._v(" "), (_vm.message) ? _c('div', [_c('div', {
    staticClass: "alert"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.resetResponse
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" " + _vm._s(_vm.message) + "\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', [_c('div', {
    staticClass: "alert"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.clearError
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" " + _vm._s(_vm.error) + "\n        ")])]) : _vm._e(), _vm._v(" "), _c('v-form', {
    staticClass: "mb-2"
  }, [_c('v-text-field', {
    staticClass: "mb-2",
    attrs: {
      "color": "white",
      "label": _vm.$t('user-params.username'),
      "rules": _vm.usernameRules,
      "required": ""
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "color": "white",
      "label": _vm.$t('user-params.password'),
      "rules": _vm.passwordRules,
      "required": "",
      "append-icon": _vm.passwordVisible ? 'visibility' : 'visibility_off',
      "append-icon-cb": function () { return (_vm.passwordVisible = !_vm.passwordVisible); },
      "type": _vm.passwordVisible ? 'text' : 'password',
      "autocomplete": "password"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-3",
    attrs: {
      "color": "blue",
      "dark": ""
    },
    on: {
      "click": _vm.checkCreds
    }
  }, [_vm._v(_vm._s(_vm.$t('login.login')))])], 1), _vm._v(" "), _c('div', [_c('router-link', {
    staticClass: "reset_pass",
    attrs: {
      "to": {
        name: 'ResetPassword'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("login.lost")))]), _c('br'), _vm._v(" "), (_vm.isHarps4) ? _c('div', [_c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "reset_pass",
    attrs: {
      "to": {
        name: 'Signup'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("login.link_to_signup")))])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('login-footer')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../src/~/vue-loader/lib/template-compiler?{"id":"data-v-527cd522","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../src/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Login.vue
// module id = 1929
// module chunks = 0